
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise",
      function () {
        return require("private-next-pages/franchise/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise"])
      });
    }
  